
import { ClickAwayListener, Tooltip } from '@material-ui/core'
import { useState } from 'react'

export function TapTooltip({
  title,
  placement = 'top',
  arrow = true,
  children,
  closeOnClick = false
}) {
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen(prev => !prev)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Tooltip
        title={title}
        placement={placement}
        arrow={arrow}
        open={open}
        // disableHoverListener
        // disableFocusListener
        // disableTouchListener
      >
        <span
          onClick={e => {
            e.stopPropagation()
            handleToggle()
            if (closeOnClick) handleClose()
          }}
          style={{ display: 'inline-flex' }}
        >
          {children}
        </span>
      </Tooltip>
    </ClickAwayListener>
  )
}
